import { StudentRequestReason, StudentRequestStatus } from '@/entities/StudentRequests';

export const STUDENT_ATTENDANCE_REASON_OPTIONS: { value: StudentRequestReason; label: string }[] = [
  { value: 'excused_absence', label: 'Excused absence' },
  { value: 'attendance_correction_request', label: 'Attendance correction request' },
  { value: 'other', label: 'Other' },
];

export const STUDENT_GENERAL_REASON_OPTIONS: { value: StudentRequestReason; label: string }[] = [
  { value: 'academic_transcript', label: 'Academic transcript' },
  { value: 'enrollment_confirmation_letter', label: 'Enrollment confirmation letter' },
  { value: 'bank_letter', label: 'Bank letter' },
  { value: 'council_tax_letter', label: 'Council tax letter' },
  { value: 'graduation_certificate', label: 'Graduation certificate' },
  { value: 'letter_of_recommendation', label: 'Letter of recommendation' },
  { value: 'proof_of_study_letter', label: 'Proof of study letter' },
  { value: 'academic_appeal', label: 'Academic appeal' },
  { value: 'deferral', label: 'Deferral' },
  { value: 'withdrawal', label: 'Withdrawal' },
  { value: 'class_swap', label: 'Class swap' },
  { value: 'deadline_extension_request', label: 'Deadline extension request' },
  { value: 'change_course_program', label: 'Change course program' },
  { value: 'change_study_mode', label: 'Change study mode' },
  { value: 'tuition_fee_inquiry', label: 'Tuition fee inquiry' },
  { value: 'payment_plan_request', label: 'Payment plan request' },
  { value: 'refund_request', label: 'Refund request' },
  { value: 'invoice_request', label: 'Invoice request' },
  { value: 'payment_confirmation', label: 'Payment confirmation' },
  { value: 'academic_complaint', label: 'Academic complaint' },
  { value: 'general_complaint', label: 'General complaint' },
  { value: 'report_harassment_misconduct', label: 'Report harassment / misconduct' },
  { value: 'appeal_disciplinary_action', label: 'Appeal disciplinary action' },
  { value: 'visa_support_letter', label: 'Visa support letter' },
  { value: 'platform_bug', label: 'Platform bug' },
  { value: 'access_issue', label: 'Access issue' },
  { value: 'assignment_upload_issue', label: 'Assignment upload issue' },
  { value: 'video_content_not_working', label: 'Video content not working' },
  { value: 'other', label: 'Other' },
];

const STUDENT_REASON_LABELS_SOURCE = [
  ...STUDENT_ATTENDANCE_REASON_OPTIONS,
  ...STUDENT_GENERAL_REASON_OPTIONS,
];

export const REQUEST_REASON_LABELS: Record<StudentRequestReason, string> = Object.fromEntries(
  STUDENT_REASON_LABELS_SOURCE.map((option) => [option.value, option.label]),
) as Record<StudentRequestReason, string>;

export const REQUEST_STATUS_LABELS: Record<StudentRequestStatus, string> = {
  new: 'In Review',
  approved: 'Approved',
  rejected: 'Rejected',
};

export const REQUEST_STATUS_CLASSES: Record<StudentRequestStatus, string> = {
  new: 'bg-[#FFE7A3] text-yellow-tertiary',
  approved: 'bg-[#DFF8E8] text-green-tertiary',
  rejected: 'bg-[#FFE0E0] text-red-tertiary',
};

export const formatRequestDate = (value?: string | null) => {
  if (!value) return '-';

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(value));
};

export const formatRequestDateTime = (value?: string | null) => {
  if (!value) return '-';

  const date = new Date(value);
  const formattedDate = formatRequestDate(value);
  const formattedTime = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);

  return `${formattedDate} ${formattedTime}`;
};

export const formatAttendanceValue = (value: number | null | undefined) =>
  value === null || value === undefined ? '-' : value === 0 ? '0.0' : value.toFixed(1);
